<template>
  <div class="module">
    <router-link to="/classement" class="lb-back-link"><i class="fa-solid fa-arrow-left"></i> Toutes les ligues</router-link>

    <div v-if="loading" class="lb-loading">Chargement...</div>
    <p v-else-if="!ligue" class="lb-loading">Ligue introuvable.</p>

    <template v-else>
      <div class="ligue-header">
        <img v-if="logoUrl(ligue.logo)" :src="logoUrl(ligue.logo)!" :alt="`Logo ${ligue.name}`" class="entity-logo" />
        <h1 class="page-title">{{ ligue.name }}</h1>
        <router-link :to="`/classement/${encodeURIComponent(ligue.code)}/ligue`" class="lb-btn">
          Voir le classement de la ligue
        </router-link>
      </div>

      <h2 class="section-title">Ou choisissez un comité</h2>
      <p v-if="!comites.length" class="lb-loading">Aucun comité rattaché à cette ligue.</p>
      <div v-else class="entity-grid">
        <router-link v-for="comite in comites"
          :to="`/classement/${encodeURIComponent(ligue.code)}/${encodeURIComponent(comite.code)}`" class="entity-card" :key="comite.id">
          <img v-if="logoUrl(comite.logo)" :src="logoUrl(comite.logo)!" :alt="`Logo ${comite.name}`"
            class="entity-logo" />
          <div v-else class="entity-logo placeholder"><i class="fa-solid fa-shield-halved"></i></div>
          <span class="entity-name">{{ comite.name }}</span>
          <span class="entity-code">{{ comite.code }}</span>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { fetchComites, fetchLigues, fetchSeasons, leaderboardSeo, logoUrl, sameCode, type Jurisdiction } from '@/functions/leaderboards';
import { applySeo } from '@/functions/seo';

const route = useRoute();
const ligue = ref<Jurisdiction | null>(null);
const comites = ref<Jurisdiction[]>([]);
const loading = ref(true);

onMounted(async () => {
  try {
    const [ligues, seasons] = await Promise.all([fetchLigues(), fetchSeasons()]);
    ligue.value = ligues.find((l) => sameCode(l.code, route.params.ligueCode as string)) ?? null;
    if (ligue.value) {
      comites.value = await fetchComites(ligue.value.code);
      const season = (seasons.find((s) => s.is_current) ?? seasons[0])?.label ?? '';
      applySeo(leaderboardSeo('ligue_home', season, ligue.value));
    }
  } catch {
    ligue.value = null;
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.ligue-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
}

.section-title {
  text-align: center;
  margin-bottom: 1rem;
}
</style>
